var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.parcoursList),function(parcours,index){return _c('span',{key:index,staticClass:"parcours-list"},[_c('span',[_vm._v(_vm._s(parcours))]),(index < _vm.last)?_c('span',[_vm._v(" · ")]):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }